module.exports = __webpack_public_path__ + "static/media/empty-chart-default.74228bb0.svg";